<script setup>
import { Head, Link } from '@inertiajs/vue3'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import AppLayout from '../../Layouts/AppLayout.vue'

const props = defineProps({
  reason: { type: String, default: 'expired' },
})

const { t } = useI18n()

const title = computed(() =>
  props.reason === 'revoked'
    ? t('messages.invitations.error.revoked_title')
    : t('messages.invitations.error.expired_title'),
)
const description = computed(() =>
  props.reason === 'revoked'
    ? t('messages.invitations.error.revoked_description')
    : t('messages.invitations.error.expired_description'),
)
</script>

<template>
  <Head :title="title" />

  <AppLayout>
    <div class="flex justify-center mt-12">
      <Card class="max-w-md w-full">
        <template #content>
          <div class="flex flex-col items-center gap-4 text-center">
            <i class="pi pi-clock text-5xl text-amber-500"></i>
            <h1 class="text-xl font-medium m-0">{{ title }}</h1>
            <p class="text-sm text-gray-600 m-0">{{ description }}</p>
            <Link :href="route('login')">
              <Button outlined>
                {{ t('messages.loginLoginIn') }}
              </Button>
            </Link>
          </div>
        </template>
      </Card>
    </div>
  </AppLayout>
</template>
